import api from "../config/api";

export async function crearTrabajo({ titulo, descripcion, autorEmail, imagenes, descripciones }) {
  const formData = new FormData();
  formData.append("Titulo", titulo);
  if (descripcion) formData.append("Descripcion", descripcion);
  if (autorEmail) formData.append("AutorEmail", autorEmail);

  if (Array.isArray(imagenes)) {
    for (const file of imagenes) {
      if (file) formData.append("Imagenes", file);
    }
  }

  if (Array.isArray(descripciones)) {
    for (const d of descripciones) {
      formData.append("Descripciones", d || "");
    }
  }

  const response = await fetch(`${api.baseURL}/trabajos`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }

  return await response.json();
}

export async function listarTrabajos() {
  const response = await fetch(`${api.baseURL}/trabajos`, {
    method: "GET",
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }

  return await response.json();
}

export async function obtenerTrabajo(id) {
  const response = await fetch(`${api.baseURL}/trabajos/${id}`, {
    method: "GET",
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }

  return await response.json();
}